var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 12L22 22L6 12V8L22 18L38 8V12ZM38 4H6C3.78 4 2 5.78 2 8V32C2 33.0609 2.42143 34.0783 3.17157 34.8284C3.92172 35.5786 4.93913 36 6 36H38C39.0609 36 40.0783 35.5786 40.8284 34.8284C41.5786 34.0783 42 33.0609 42 32V8C42 5.78 40.2 4 38 4Z",
    fill: "#324485"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 16L22 21L14 16V14L22 19L30 14V16ZM30 12H14C12.89 12 12 12.89 12 14V26C12 26.5304 12.2107 27.0391 12.5858 27.4142C12.9609 27.7893 13.4696 28 14 28H30C30.5304 28 31.0391 27.7893 31.4142 27.4142C31.7893 27.0391 32 26.5304 32 26V14C32 12.89 31.1 12 30 12Z",
    fill: "#1F2351"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12C33.1109 12 30.2501 12.569 27.581 13.6747C24.9118 14.7803 22.4865 16.4008 20.4437 18.4437C16.3179 22.5695 14 28.1652 14 34C14 39.8348 16.3179 45.4306 20.4437 49.5564C22.4865 51.5992 24.9118 53.2197 27.581 54.3254C30.2501 55.431 33.1109 56 36 56C41.8348 56 47.4306 53.6822 51.5564 49.5564C55.6822 45.4306 58 39.8348 58 34C58 31.1109 57.431 28.2501 56.3254 25.581C55.2197 22.9118 53.5992 20.4865 51.5564 18.4437C49.5135 16.4008 47.0882 14.7803 44.419 13.6747C41.7499 12.569 38.8891 12 36 12Z",
    fill: "#97CEE5",
    fillOpacity: 0.98
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.26 42.8L25 35.54L28.08 32.46L32.26 36.64L43.92 24.98L47 28.06L32.26 42.8Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0,
    y: 0,
    width: 44,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 19,
    y: 18.98,
    width: 38,
    height: 33.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.266667 0 0 0 0 0.521569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterEmail);
export default __webpack_public_path__ + "static/media/register-email.824146c9ff2fa7b1c66dc9868b37e352.svg";
export { ForwardRef as ReactComponent };